import {
    Placeholder,
    PlaceholderMedia,
    PlaceholderLine,
    ShineOverlay,
  } from 'rn-placeholder';

import React, { Component } from 'react';

import {
    responsiveHeight,
    responsiveWidth,
  } from 'react-native-responsive-dimensions';

export default class PlaceholderComp extends Component {

    render() {
        return (
                
            <Placeholder
                Animation={ShineOverlay}
                style={{
                    marginVertical: 6,
                    marginHorizontal: -10,
                    borderRadius: 4,
                }}
                Right={props => (
                    <PlaceholderMedia
                    style={[
                        props.style,
                        {
                        width: 95,
                        height: 95,
                        },
                    ]}
                    />
                )}
            >
                <PlaceholderLine style={{ marginTop: responsiveHeight(1) }} width={70} />
                <PlaceholderLine style={{ marginTop: responsiveHeight(1.5) }} width={50} />
                <PlaceholderLine width={50} />
            </Placeholder>

        );
    }
};